/**
 * Label for the case-chat push-to-talk control.
 * Shown only when mode === 'ptt' (see CaseWorkspace).
 */
export function pttComposerLabel(opts: { micReady: boolean; pttHeld: boolean }): string {
  if (!opts.micReady) return 'Enable mic';
  if (opts.pttHeld) return 'Release to send';
  return 'Push to Talk';
}

/**
 * First press enables the mic only; a later press starts hold-to-talk.
 * Avoids leaving the control stuck on "Release to send" after a short enable click.
 */
export async function pttActivateOnPointerDown(opts: {
  micReady: boolean;
  startMic: () => Promise<void>;
  pttDown: () => void;
}): Promise<'mic-enabled' | 'ptt-held'> {
  if (!opts.micReady) {
    await opts.startMic();
    return 'mic-enabled';
  }
  opts.pttDown();
  return 'ptt-held';
}
